import update from 'react-addons-update';
import {
	SAMPLE_SEARCH_SUCCESS
} from './action.js';

const initState = {
	action: null,
	searchResponse: []
};

export default function welcomReducer(state = initState, action) {
	switch (action.type) {
		case SAMPLE_SEARCH_SUCCESS:
			return update(state, {
				action: { $set: SAMPLE_SEARCH_SUCCESS },
				searchResponse: { $set: action.data }
			});
		default:
			return state;
	}
}